/// <amd-module name="Wit/WorkItemModel/WorkItem/LegacyStore" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IWorkItemLinkTypeEnd } from "Wit/WorkItemDataManager/Contracts";
import { ILegacyWorkItemStore } from "Wit/WorkItemModel/OM/ILegacyWorkItem";
import { LegacyTfsConnection } from "./LegacyTfsConnection";

export class LegacyWorkItemStore implements ILegacyWorkItemStore {
    public tfsConnection: LegacyTfsConnection;
    private _linkTypeEnds: IWorkItemLinkTypeEnd[];

    constructor(pageContext: IVssPageContext, linkTypeEnds: IWorkItemLinkTypeEnd[]) {
        this.tfsConnection = new LegacyTfsConnection(pageContext);
        this._linkTypeEnds = linkTypeEnds;
    }

    public findLinkTypeEnd(idOrName: number | string): IWorkItemLinkTypeEnd {
        const search = ("" + idOrName).toUpperCase();

        for (const linkTypeEnd of this._linkTypeEnds) {
            if (linkTypeEnd.id === idOrName) {
                return linkTypeEnd;
            } else if (linkTypeEnd.name.toUpperCase() === search) {
                return linkTypeEnd;
            } else if (linkTypeEnd.immutableName.toUpperCase() === search) {
                return linkTypeEnd;
            }
        }

        throw Error();
    }
}
